// Reference-counted body scroll lock. Multiple independent UI layers (mobile
// nav menu, ad popup, etc.) can each want the body scroll locked at once; a
// naive "capture previous value, restore on cleanup" approach in each one
// breaks when two lockers overlap and close out of order — the second
// cleanup can restore an inline style the first locker already replaced,
// leaving the body permanently locked or unlocked incorrectly. Routing every
// locker through this shared counter fixes that regardless of open/close order.
let lockCount = 0;
let previousOverflow = "";

export function lockBodyScroll(): () => void {
  if (lockCount === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  lockCount++;

  let released = false;
  return () => {
    if (released) return;
    released = true;
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      document.body.style.overflow = previousOverflow;
    }
  };
}
